module.exports = __webpack_public_path__ + "img/arrow-right.ed29f298.svg";